import { useFlags } from "launchdarkly-react-client-sdk";
import { UseSectionHook } from "src/components/layout/nav/sections/types";
import { useResourcePermission } from "src/components/permission/use-resource-permission";
import { useEntitlements } from "src/hooks/use-entitlement";
import { runChartPermission } from "src/pages/analytics/permissions";

export const useIntelligenceSection: UseSectionHook = () => {
  const { data: entitlementsData } = useEntitlements(false);
  const { appExperimentsM2Enabled } = useFlags();

  return {
    title: "Intelligence",
    isEnabled: entitlementsData.entitlements.analytics,
    links: [
      {
        href: "/analytics",
        label: "Charts",
      },
      {
        href: "/dashboards",
        label: "Dashboards",
      },
      appExperimentsM2Enabled && {
        href: "/experiments",
        label: "Experiments",
      },
      {
        href: "/metrics",
        label: "Metrics",
      },
      entitlementsData.entitlements.campaigns && {
        href: "/campaigns",
        label: "Campaigns",
      },
    ],
  };
};

export const useChartsPermission = ({
  parentModelId,
}: {
  parentModelId: string;
}): boolean => {
  const { data: entitlementsData } = useEntitlements(false);
  // Does this workspace have access to analytics?
  const hasChartsAccess = entitlementsData.entitlements.analytics;
  const chartsPermission = runChartPermission(parentModelId);

  // Does this user have permission to view charts?
  const { isPermitted: hasChartsPermission } =
    useResourcePermission(chartsPermission);

  return hasChartsAccess && hasChartsPermission;
};
